import dayjs from 'dayjs';

import type { FilterValue } from '@rd/Filters/types';

export const fromStringToDayjs = (value: string, defaultValue: FilterValue = null) => {
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : defaultValue;
};
